// Pont front-end pour le suivi de conversion Meta (Pixel + Conversions API).
// Expose window.QjcMeta pour les scripts inline des vues (courses/show,
// _form_for_people_course) qui ne passent pas par le pipeline de modules ES.
const CONSENT_COOKIE = 'qjc_meta_consent';
const UTM_STORAGE_KEY = 'qjc_utm_params';
const UTM_MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 jours
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
}

function hasConsent() {
  return getCookie(CONSENT_COOKIE) === 'accepted';
}

function generateEventId() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }

  // Fallback uuid v4 pour les navigateurs sans crypto.randomUUID.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Capture les utm_* de l'URL courante et les persiste ~30 jours pour qu'ils
// survivent à la navigation jusqu'aux metadata Stripe (source de vérité canal
// de vente, cf. courses_people.utm_*).
function captureUtmParams() {
  const params = new URLSearchParams(window.location.search);
  const found = {};

  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) found[key] = value;
  });

  if (Object.keys(found).length === 0) return;

  try {
    window.localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify({ values: found, storedAt: Date.now() }));
  } catch (e) {
    // localStorage indisponible (navigation privée, quota...) : on ignore.
  }
}

function getStoredUtmParams() {
  try {
    const raw = window.localStorage.getItem(UTM_STORAGE_KEY);
    if (!raw) return {};

    const payload = JSON.parse(raw);
    if (!payload.storedAt || Date.now() - payload.storedAt > UTM_MAX_AGE_MS) {
      window.localStorage.removeItem(UTM_STORAGE_KEY);
      return {};
    }

    return payload.values || {};
  } catch (e) {
    return {};
  }
}

function getFacebookCookies() {
  return {
    fbp: getCookie('_fbp'),
    fbc: getCookie('_fbc')
  };
}

// Garde-fou anti double-déclenchement (clic accidentel en double, retour
// arrière/avant, pré-chargement de lien par le navigateur...). PageView est
// protégé par le "if (window.fbq) return" du snippet Pixel; ViewContent et
// InitiateCheckout n'ont pas cette protection naturelle, d'où ce dédoublonnage
// explicite sur une courte fenêtre pour éviter de fausser les données de
// campagne avec des conversions comptées en double.
const recentFires = new Map();
const DEDUPE_WINDOW_MS = 3000;

function track(eventName, data) {
  const key = `${eventName}:${data.contentId}:${window.location.href}`;
  const now = Date.now();
  const lastFiredAt = recentFires.get(key);

  if (lastFiredAt && now - lastFiredAt < DEDUPE_WINDOW_MS) {
    return null;
  }
  recentFires.set(key, now);

  const eventId = generateEventId();

  if (window.fbq && hasConsent()) {
    window.fbq('track', eventName, {
      content_ids: [String(data.contentId)],
      content_name: data.contentName,
      content_type: 'product',
      value: data.value,
      currency: 'CAD'
    }, { eventID: eventId });
  }

  return eventId;
}

function trackViewContent(data) {
  return track('ViewContent', data);
}

function trackInitiateCheckout(data) {
  return track('InitiateCheckout', data);
}

function initUtmCapture() {
  captureUtmParams();
}

window.QjcMeta = {
  hasConsent,
  trackViewContent,
  trackInitiateCheckout,
  getStoredUtmParams,
  getFacebookCookies
};

export { initUtmCapture };
